import clsx from 'clsx';

// "Dr K. S. Mhaskar" -> "KM". Shown in the circle until a real photo exists.
export function initials(name: string): string {
  const words = name.split(/\s+/).filter((w) => !/^(dr|mr|mrs|ms)\.?$/i.test(w));
  const first = words[0]?.[0] ?? '';
  const last = words.length > 1 ? (words[words.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase();
}

interface Props {
  name: string;
  /** The photo's URL, or undefined when ITES has not supplied one. */
  src?: string;
  size?: 'md' | 'lg'; // 56px | 64px
  className?: string;
}

// A round portrait. The person's name always appears as text next to it, so the
// image itself is decorative (empty alt) and the initials are hidden from screen readers.
export function Portrait({ name, src, size = 'lg', className }: Props) {
  const box = size === 'lg' ? 'size-16' : 'size-14';
  if (src) {
    return (
      <img
        src={src}
        alt=""
        width={128}
        height={128}
        loading="lazy"
        decoding="async"
        className={clsx(box, 'flex-none rounded-full bg-img-fallback object-cover object-top', className)}
      />
    );
  }
  return (
    <div
      aria-hidden="true"
      className={clsx(
        box,
        'flex flex-none items-center justify-center rounded-full bg-sky-50 font-serif font-semibold text-navy-800',
        size === 'lg' ? 'text-[1.375rem]' : 'text-[1.25rem]',
        className,
      )}
    >
      {initials(name)}
    </div>
  );
}
